// extracted by mini-css-extract-plugin
export default {"svgImageSource":"cIhIwa","svgImageRoot":"SC3q0n"};